export enum SensorMetric {
  Temperature = 'temperature',
  Humidity = 'humidity',
}

export enum SensorMetricSymbol {
  Temperature = '°C',
  Humidity = '%',
}
